export default __webpack_public_path__ + "static/media/glitch.e2e13108.gif";